import React, { useEffect, useState } from "react";
import CoreSelectObjArr from "../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { t } from "i18next";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import StudioFilter from "../../../../app/core/components/UserFilter/StudioFilter";
import { useGetStudioIdQuery } from "../../../api/admin/gestisciStudioApi";
import { ROLE } from "../../../../utils/constants/profiles";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@mui/material";

const SingleUserForm = ({
  form,
  index,
  handleFormChange,
  handleFormSameRefStudioChange,
  dataListCategory,
  studios,
  setDebouncedInputStudioValue,
  validationErrors,
}) => {
  const role = useSelector((state) => state.app.role);
  const [studio, setStudio] = useState();

  useEffect(() => {
    if (studio?.id) handleFormChange(undefined, index, "studio", studio?.id);
    else handleFormChange(undefined, index, "studio", "");
    setDebouncedInputStudioValue("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  const { data: operatorsData } = useGetStudioIdQuery(studio?.id, {
    skip: !studio,
  });

  const commercialistiOptions = operatorsData?.Data?.admins?.map((user) => ({
    label: `${user?.name} ${user.surname}`,
    value: user?.id,
  }));

  return (
    <div className="mt-4 w-full flex flex-col">
      <h4>
        {t("AdditionalUser")} {index + 1}
      </h4>
      <div className="flex gap-20 px-16">
        <CoreInputField
          className="w-full"
          label={t("Name")}
          type="text"
          name="nome"
          value={form.nome}
          onChange={(event) => handleFormChange(event, index)}
          required={true}
          error={Boolean(validationErrors?.nome)}
          helperText={validationErrors?.nome}
        />

        <CoreInputField
          className="w-full"
          label={t("Surname")}
          type="text"
          name="cognome"
          value={form.cognome}
          onChange={(event) => handleFormChange(event, index)}
          required={true}
          error={Boolean(validationErrors?.cognome)}
          helperText={validationErrors?.cognome}
        />
      </div>

      <div className="flex gap-20 px-16 items-end">
        <CoreInputField
          className="w-full"
          label="Email"
          type="email"
          name="email"
          value={form.email}
          onChange={(event) => handleFormChange(event, index)}
          required={true}
          error={Boolean(validationErrors?.email)}
          helperText={validationErrors?.email}
        />

        <CoreInputField
          label={t("CF")}
          className="w-full"
          type="text"
          name="codiceFiscale"
          value={form.codiceFiscale}
          onChange={(event) => handleFormChange(event, index)}
          //required={true}
          error={Boolean(validationErrors?.codiceFiscale)}
          helperText={validationErrors?.codiceFiscale}
        />
        {role !== ROLE.ADMIN && ( //questa ripetizione è dovuta al layout
          <CoreSelectObjArr
            name="occupazione"
            label={t("SelectEmployment")}
            value={form.occupazione}
            items={dataListCategory?.Data.map((el) => ({
              label: el.name,
              value: el.id,
            }))}
            onChange={(event) => handleFormChange(event, index)}
            error={Boolean(validationErrors?.occupazione)}
            helperText={validationErrors?.occupazione}
          />
        )}
      </div>
      {role === ROLE.ADMIN && ( //questa ripetizione è dovuta al layout, essendoci meno campi per lo studio admin (da migliorare)
        <div className="flex gap-20 px-16 mt-6">
          <CoreSelectObjArr
            className="w-1/2"
            name="occupazione"
            label={t("SelectEmployment")}
            value={form.occupazione}
            items={dataListCategory?.Data.map((el) => ({
              label: el.name,
              value: el.id,
            }))}
            onChange={(event) => handleFormChange(event, index)}
            error={Boolean(validationErrors?.occupazione)}
            helperText={validationErrors?.occupazione}
          />

          <FormControlLabel
            className="w-1/2"
            control={
              <Checkbox
                name="sameRefStudio"
                checked={form.sameRefStudio}
                onChange={(e) => {
                  handleFormSameRefStudioChange(e, index);
                  setStudio();
                }}
              />
            }
            label={t("RefStudioMatch")}
          />
        </div>
      )}
      {!form.sameRefStudio && (
        <div className="flex gap-20 px-16 mt-6">
          <StudioFilter
            selectedUser={studio}
            setSelectedUser={(value) => setStudio(value)}
            usersList={studios?.Data?.items}
            setDebouncedInputUserValue={setDebouncedInputStudioValue}
            isError={validationErrors?.studio}
          />
          <CoreSelectObjArr
            name="commercialista"
            label={`${t("SelectOperator")}`}
            value={form.commercialista}
            onChange={(event) => handleFormChange(event, index)}
            items={commercialistiOptions || []}
            error={Boolean(validationErrors?.commercialista)}
            helperText={validationErrors?.commercialista}
          />
        </div>
      )}
    </div>
  );
};

export default SingleUserForm;
